import React from "react";

export default function LegalPrivacy() {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:64px_64px]" />
      
      <div className="max-w-4xl mx-auto relative z-10">
        <div className="bg-card/80 backdrop-blur-md border border-border/50 rounded-3xl p-8 shadow-2xl ring-1 ring-white/10">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h1 className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent text-3xl font-bold">
              プライバシーポリシー
            </h1>
            <p className="text-muted-foreground mt-2">個人情報の取扱いについて</p>
          </div>

          <div className="prose prose-invert max-w-none">
            <h2 className="text-xl font-semibold text-foreground mb-4">取得情報</h2>
            <ul className="text-foreground space-y-2">
              <li>メールアドレス・氏名等のアカウント情報</li>
              <li>Stripeの顧客ID・支払い状況（カード番号はStripeが保持）</li>
              <li>アクセスログ（IP等）</li>
            </ul>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">利用目的</h2>
            <ul className="text-foreground space-y-2">
              <li>本人確認・課金・サポート</li>
              <li>品質向上・不正防止</li>
            </ul>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">第三者提供</h2>
            <p className="text-foreground">決済処理のためStripeに提供。法令に基づく場合を除き、その他の第三者提供なし。</p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">問い合わせ</h2>
            <p className="text-foreground">customer-support-cashless@cashlessmap.com まで。</p>
          </div>
        </div>
      </div>
    </div>
  );
}
